/**
 * Rotas públicase Navegação do Agendex
 * autor: W de Paula
 * data: 31/12/25 | 11h39
 */




/**
 * src/routes/publicRoutes.js
 * Rotas públicas (sem autenticação)
 */

import { lazy, Suspense } from 'react';
import LoadingSpinner from '../app/ComponentsLogin/LoadingSpinner';

// ROTAS INICIAIS
const Site = lazy(() => import('../site/pages/home'));
const PrecosCRM = lazy(() => import('../site/pages/precoscrm'));

// LOGIN E CADASTRO
const LoginGlobal = lazy(() => import('../app/Login/loginmodal'));
const LoginAdmin = lazy(() => import('../app/Login/loginadmin'));
const LoginCliente = lazy(() => import('../app/Login/logincliente'));
const LoginPrestador = lazy(() => import('../app/Login/loginprestador'));

const NovaContaGlobal = lazy(() => import('../app/NovaConta/novacontamodal'));
const NovaContaCliente = lazy(() => import('../app/NovaConta/novacontacliente'));
const NovaContaPrestador = lazy(() => import('../app/NovaConta/novacontaprestador'));

// RESET SENHA
const ResetSenha = lazy(() => import('../app/ResetSenha/resetsenha'));
const ResetSenhaCV = lazy(() => import('../app/ResetSenha/resetsenhacv'));

// LINKS PERSONALIZADOS (PÚBLICOS)
const PrestadorProfile = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/prestadorprofile'));
const PrestadorServicosSemColaborador = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/prestadorservicos'));
const ProfissionaisServicos = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/profissionaiseservicos'));
const Agendamento = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/profissionalagendamento'));
const ConfirmacaoAgendamento = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/profissionalconfirmacaoagendamento'));
const PrestadorAgendamento = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/prestadoragendamento'));
const PrestadorConfirmacaoAgendamento = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/prestadorconfirmacaoagendamentos'));
const HistoricoAgendamentos = lazy(() => import('../app/AgendexCliente/pages/PrestadorProfile/historicoagendamentos'));

// HELPER
const withSuspense = (Component) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Component />
  </Suspense>
);

export const publicRoutes = [
  { path: "/", element: withSuspense(Site) },
  { path: "/precos", element: withSuspense(PrecosCRM) },
  
  { path: "/app/login", element: withSuspense(LoginGlobal) },
  { path: "/app/login/admin", element: withSuspense(LoginAdmin) },
  { path: "/app/login/cliente", element: withSuspense(LoginCliente) },
  { path: "/app/login/prestador", element: withSuspense(LoginPrestador) },
  
  { path: "/app/novaconta", element: withSuspense(NovaContaGlobal) },
  { path: "/app/novaconta/cliente", element: withSuspense(NovaContaCliente) },
  { path: "/app/novaconta/prestador", element: withSuspense(NovaContaPrestador) },
  
  { path: "/app/resetsenha", element: withSuspense(ResetSenha) },
  { path: "/app/resetsenha/cv", element: withSuspense(ResetSenhaCV) },
  
  { path: "agendar/:linkPersonalizado", element: withSuspense(PrestadorProfile) },
  { path: "/agendar/:linkpersonalizado/:id/profissionais", element: withSuspense(ProfissionaisServicos) },
  { path: "/agendar/:linkpersonalizado/:id/profissional/:profId/servico/:servId/agendamento", element: withSuspense(Agendamento) },
  { path: "/agendar/:linkpersonalizado/:id/profissional/:profId/servico/:servId/agendamento/:reservaId", element: withSuspense(ConfirmacaoAgendamento) },
  { path: "/agendar/:linkpersonalizado/:id/servico", element: withSuspense(PrestadorServicosSemColaborador) },
  { path: "/agendar/:linkpersonalizado/:id/servico/:servId/agendamento/", element: withSuspense(PrestadorAgendamento) },
  { path: "/agendar/:linkpersonalizado/:id/servico/:servId/agendamento/:reservaId", element: withSuspense(PrestadorConfirmacaoAgendamento) },
  { path: "/agendar/historico", element: withSuspense(HistoricoAgendamentos) }
];